// utils
import { setDevMode } from '../../utils/configHelpers';
import './oauth';
import './server';

// local, dev, prod
setDevMode('prod');
